import { createClient } from '@supabase/supabase-js';

// Ensure your .env file uses REACT_APP_ prefix for variables to be available in React
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY as string;

// If these log as undefined, check your .env file location, variable names, and restart the dev server.
if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase environment variables are missing:', {
    supabaseUrl,
    supabaseAnonKey,
  });
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);